import { mapGetters } from 'vuex'

function createRouterLink (initialObj = {}) {
  const methods = {
    withQuery (params) {
      return createRouterLink({
        ...this,
        query: params
      })
    }
  }

  const handler = {
    get (target, prop) {
      if (prop in target) {
        return target[prop]
      }

      if (prop in methods) {
        return methods[prop].bind(target)
      }

      return undefined
    }
  }

  return new Proxy({ ...initialObj }, handler)
}

export default {
  computed: {
    ...mapGetters({
      activeResourceType: 'publicView/getResourceType',
      publicViewSelected: 'publicView/getSelected'
    })
  },
  methods: {
    currentPublicRoute () {
      return createRouterLink({
        name: 'public',
        params: {
          type: this.publicViewSelected.type || 'ou',
          id: this.publicViewSelected.id || 1,
          resourceType: this.activeResourceType || 'forschungsprojekt'
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/PublicRouteBuilder.js